<template>
  <div>
    <Layout :pagetitle="$t('Affiliate report')">
      <b-card>
        <b-row>
          <b-col class="m-2">
            <b-row>
              <b-col md="3">
                <label>{{ $t('Brand') }}</label>
                <brandSelectorUnique :modelValue="idBrand" @onChange="changeBrandFilter" />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Sub Brand') }}</label>
                <subBrandsSelector
                  :mode="'single'"
                  :modelValue="idSubBrand"
                  @onChange="setSubBrand"
                  :allowEmpty="true"
                />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Data Início') }}</label>
                <input class="form-control" type="date" v-model="startDate" />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Data Fim') }}</label>
                <input class="form-control" type="date" v-model="endDate" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="8" />
              <b-col md="4">
                <div class="table-buttons">
                  <button class="btn btn-sm btn-success" :disabled="!reportData.length" @click="downloadXls">
                    {{ $t('XLS') }}
                  </button>
                  <button
                    class="ml-1 btn btn-sm btn-primary"
                    :disabled="!idBrand || !startDate || !endDate"
                    @click="getAffiliateReport"
                  >
                    {{ $t('Buscar') }}
                  </button>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row v-if="reportData.length">
          <b-col class="">
            <div class="card my-0 py-0 border border-primary">
              <div class="card-header bg-transparent border-primary py-0">
                <h5 class="my-0 text-primary">
                  <i :class="`fas fa-ticket-alt me-3`"></i>
                  {{ $t('Summary') }}
                </h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Turnover') }}
                    </span>
                    <span class="h5 text-center"> {{ $utils.formatMoneyFloat(reportTotal.turnover) }} </span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Prêmio') }}
                    </span>
                    <span class="h5">{{ $utils.formatMoneyFloat(reportTotal.payout) }}</span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Bônus') }}
                    </span>
                    <span class="h5">{{ $utils.formatMoneyFloat(reportTotal.bonus) }}</span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('GGR') }}
                    </span>
                    <span class="h5">{{ $utils.formatMoneyFloat(reportTotal.ggr) }}</span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Taxa Admin.') }}
                    </span>
                    <span class="h5">{{ $utils.formatMoneyFloat(reportTotal.admin_fee) }}</span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Líquido') }}
                    </span>
                    <span class="h5">{{ $utils.formatMoneyFloat(reportTotal.net) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 summary-column">
                    <span class="text-muted small d-block"> {{ $t('Users') }} ({{ $t('Active') }}) </span>
                    <span class="h5">{{ reportTotal.active_customers_count }}</span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Comissão') }}
                    </span>
                    <span class="h5">{{ $utils.formatMoneyFloat(reportTotal.reward_accumulative) }}</span>
                  </div>
                  <div class="summary-column" v-if="!hideCpa">
                    <span class="text-muted small d-block">
                      {{ $t('Qtd CPA') }}
                    </span>
                    <span class="h5">{{ reportTotal.reward_mark_count }}</span>
                  </div>
                  <div class="summary-column" v-if="!hideCpa">
                    <span class="text-muted small d-block">
                      {{ $t('CPA') }}
                    </span>
                    <span class="h5">{{ $utils.formatMoneyFloat(reportTotal.reward_mark) }}</span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Total') }}
                    </span>
                    <span class="h5">{{ $utils.formatMoneyFloat(reportTotal.reward_total) }}</span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block"> {{ $t('Users') }} ({{ $t('Register') }}) </span>
                    <span class="h5">{{ reportTotal.registered_customers_count }}</span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('FTD') }}
                    </span>
                    <span class="h5">{{ reportTotal.ftd_count }}</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <Table
          :key="hideCpa"
          :title="''"
          :items="reportData"
          :columns="computedColumns"
          :totalItems="reportData.length"
          :showButtons="false"
          :searchable="false"
          :editable="false"
          :removable="false"
          :showPagination="false"
          :isCard="false"
        />
      </b-card>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';
import staticData from './staticData';
import { exportXls } from './functions';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import moment from 'moment';
import subBrandsSelector from '@/components/selectors/subBrandsSelector';

export default {
  components: { Layout, Table, brandSelectorUnique, subBrandsSelector },
  data() {
    return {
      startDate: moment(moment().format('YYYY-MM')).subtract('months', 1).format('YYYY-MM-DD'),
      endDate: moment(moment().format('YYYY-MM')).subtract('days', 1).format('YYYY-MM-DD'),
      idBrand: null,
      idSubBrand: null,
      reportData: [],
      reportTotal: {
        name: '',
        token: '',
        active_customers_count: 0,
        registered_customers_count: 0,
        ftd_count: 0,
        turnover: 0,
        payout: 0,
        bonus: 0,
        ggr: 0,
        admin_fee: 0,
        net: 0,
        reward_accumulative: 0,
        reward_mark_count: 0,
        reward_mark: 0,
        reward_total: 0,
        bets_turnover: 0,
        bets_payout: 0,
        bets_bonus: 0,
        bets_reward: 0,
        bets_admin_fee: 0,
        games_turnover: 0,
        games_payout: 0,
        games_bonus: 0,
        games_reward: 0,
        games_admin_fee: 0,
        lotto_turnover: 0,
        lotto_payout: 0,
        lotto_bonus: 0,
        lotto_reward: 0,
        lotto_admin_fee: 0
      },
      columns: staticData().columns
    };
  },
  computed: {
    hideCpa() {
      this.$store.state.companySettings;
      return this.shouldHideCpa();
    },
    computedColumns() {
      this.$store.state.companySettings;
      let cols = staticData().columns;
      if (this.hideCpa) {
        cols = cols.filter((col) => col.key !== 'reward_mark_count' && col.key !== 'reward_mark');
      }
      return cols;
    }
  },
  methods: {
    setSubBrand(id = null) {
      this.idSubBrand = id;
    },
    getAffiliateReport() {
      this.$store.commit('SET_LOADING', true);

      this.reportTotal.active_customers_count = 0;
      this.reportTotal.registered_customers_count = 0;
      this.reportTotal.ftd_count = 0;

      this.reportTotal.turnover = 0;
      this.reportTotal.payout = 0;
      this.reportTotal.bonus = 0;
      this.reportTotal.ggr = 0;
      this.reportTotal.admin_fee = 0;
      this.reportTotal.net = 0;
      this.reportTotal.reward_accumulative = 0;
      this.reportTotal.reward_mark_count = 0;
      this.reportTotal.reward_mark = 0;
      this.reportTotal.reward_total = 0;
      this.reportTotal.bets_turnover = 0;
      this.reportTotal.bets_payout = 0;
      this.reportTotal.bets_bonus = 0;
      this.reportTotal.bets_reward = 0;
      this.reportTotal.bets_admin_fee = 0;
      this.reportTotal.games_turnover = 0;
      this.reportTotal.games_payout = 0;
      this.reportTotal.games_bonus = 0;
      this.reportTotal.games_reward = 0;
      this.reportTotal.games_admin_fee = 0;
      this.reportTotal.lotto_turnover = 0;
      this.reportTotal.lotto_payout = 0;
      this.reportTotal.lotto_bonus = 0;
      this.reportTotal.lotto_reward = 0;
      this.reportTotal.lotto_admin_fee = 0;

      let payload = {
        idBrand: this.idBrand,
        startDate: this.startDate,
        endDate: this.endDate
      };

      if (this.idSubBrand) {
        payload['idSubBrand'] = this.idSubBrand;
      }

      this.$api
        .get('api/affiliateGrouped/report', payload)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.reportData = res.data;
          this.reportData.forEach((data) => {
            this.reportTotal.active_customers_count += Number(data.active_customers_count);
            this.reportTotal.registered_customers_count += Number(data?.registered_customers_count || 0);
            this.reportTotal.ftd_count += Number(data?.ftd_count || 0);
            this.reportTotal.turnover += Number(data.turnover);
            this.reportTotal.payout += Number(data.payout);
            this.reportTotal.bonus += Number(data.bonus);
            this.reportTotal.ggr += Number(data.ggr);
            this.reportTotal.admin_fee += Number(data.admin_fee);
            this.reportTotal.net += Number(data.net);
            this.reportTotal.reward_accumulative +=
              Number(data.reward_accumulative) > 0 ? Number(data.reward_accumulative) : 0;
            this.reportTotal.reward_mark_count += Number(data.reward_mark_count);
            this.reportTotal.reward_mark += Number(data.reward_mark);
            this.reportTotal.reward_total += Number(data.reward_total);
            this.reportTotal.bets_turnover += Number(data?.bets_turnover || 0);
            this.reportTotal.bets_payout += Number(data?.bets_payout || 0);
            this.reportTotal.bets_bonus += Number(data?.bets_bonus || 0);
            this.reportTotal.bets_reward += Number(data?.bets_reward || 0);
            this.reportTotal.bets_admin_fee += Number(data?.bets_admin_fee || 0);
            this.reportTotal.games_turnover += Number(data?.games_turnover || 0);
            this.reportTotal.games_payout += Number(data?.games_payout || 0);
            this.reportTotal.games_bonus += Number(data?.games_bonus || 0);
            this.reportTotal.games_reward += Number(data?.games_reward || 0);
            this.reportTotal.games_admin_fee += Number(data?.games_admin_fee || 0);
            this.reportTotal.lotto_turnover += Number(data?.lotto_turnover || 0);
            this.reportTotal.lotto_payout += Number(data?.lotto_payout || 0);
            this.reportTotal.lotto_bonus += Number(data?.lotto_bonus || 0);
            this.reportTotal.lotto_reward += Number(data?.lotto_reward || 0);
            this.reportTotal.lotto_admin_fee += Number(data?.lotto_admin_fee || 0);
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    changeBrandFilter(idBrand) {
      this.idBrand = idBrand;
    },
    downloadXls() {
      exportXls([...this.reportData, this.reportTotal]);
    }
  }
};
</script>

<style lang="scss">
.summary-column {
  white-space: nowrap !important;
  // min-width: 150px;
  flex: 1;
}

.summary-column-sm {
  min-width: 120px;
  flex: 1;
}

.summary-column-lg {
  min-width: 180px;
  flex: 1;
}
</style>
